module.exports = __webpack_public_path__ + "img/charging-hub-suggestion-semipublic.45823267.svg";